import Vue from 'vue'

Vue.filter('avatar', function (val) {
  if (!val || !val.first_name) {
    return "?";
  } else {
    return val.first_name[0] + (val.last_name ? val.last_name[0] : "");
  }
})